export default {
  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.401.title': '您的账户没有访问权限',
  'pages.401.subTitle': '无法找到您尝试访问的账户。\n请核实您输入的信息，或联系系统管理员寻求帮助。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  // 参数管理页面
  'pages.paramManagement.title': '参数管理',
  'pages.paramManagement.parameterName': '参数名称',
  'pages.paramManagement.moduleApplied': '应用模块',
  'pages.paramManagement.creator': '创建人',
  'pages.paramManagement.createdTime': '创建时间',
  'pages.paramManagement.actions': '操作',
  'pages.paramManagement.edit': '编辑',
  'pages.paramManagement.search': '搜索',
  'pages.paramManagement.reset': '重置',
  'pages.paramManagement.add': '添加',
  'pages.paramManagement.total': '总计',
  'pages.paramManagement.parameterConfiguration': '参数配置',
  // 用户管理页面
  'pages.userManagement.title': '用户管理',
  'pages.userManagement.index': '序号',
  'pages.userManagement.account': '账号',
  'pages.userManagement.staffName': '员工姓名',
  'pages.userManagement.staffNameEn': '员工姓名(英文)',
  'pages.userManagement.staffNameCn': '员工姓名(中文)',
  'pages.userManagement.staffNo': '员工编号',
  'pages.userManagement.costCenter': '成本中心',
  'pages.userManagement.creator': '创建人',
  'pages.userManagement.createdTime': '创建时间',
  'pages.userManagement.status': '状态',
  'pages.userManagement.actions': '操作',
  'pages.userManagement.edit': '编辑',
  'pages.userManagement.delete': '删除',
  'pages.userManagement.search': '搜索',
  'pages.userManagement.add': '添加',
  'pages.userManagement.export': '导出',
  'pages.userManagement.total': '总计',
  'pages.userManagement.statusUpdated': '状态更新成功',
  'pages.userManagement.deleted': '删除成功',
  'pages.userManagement.deleteConfirm': '此操作将删除用户，且无法恢复。',
  'pages.userManagement.exportFailed': '导出失败',
  'pages.userManagement.loadFailed': '加载用户失败',
  // 用户管理创建/编辑页面
  'pages.userManagement.createUser': '创建用户',
  'pages.userManagement.editUser': '编辑用户',
  'pages.userManagement.accountPlaceholder': '请输入账号',
  'pages.userManagement.accountRequired': '账号是必填项！',
  'pages.userManagement.accountInvalid': '请输入有效的邮箱地址',
  'pages.userManagement.staffNameEnPlaceholder': '请输入姓名',
  'pages.userManagement.staffNameEnRequired': '员工姓名(英文)是必填项！',
  'pages.userManagement.staffNameCnPlaceholder': '请输入中文姓名',
  'pages.userManagement.staffNameCnRequired': '员工姓名(中文)是必填项！',
  'pages.userManagement.staffNoPlaceholder': '请输入员工编号',
  'pages.userManagement.staffNoRequired': '员工编号是必填项！',
  'pages.userManagement.costCenterPlaceholder': '请选择成本中心',
  'pages.userManagement.costCenterRequired': '成本中心是必填项！',
  'pages.userManagement.cancel': '取消',
  'pages.userManagement.ok': '确定',
  'pages.userManagement.create': '创建',
  'pages.userManagement.updateSuccess': '用户更新成功',
  'pages.userManagement.createSuccess': '用户创建成功',
  'pages.userManagement.updateFailed': '用户更新失败',
  'pages.userManagement.createFailed': '用户创建失败',
  // 角色管理页面
  'pages.roleManagement.title': '角色管理',
  'pages.roleManagement.roleName': '角色名称',
  'pages.roleManagement.staffList': '员工列表',
  'pages.roleManagement.search': '搜索',
  'pages.roleManagement.searchPlaceholder': '搜索',
  'pages.roleManagement.total': '总计',
  'pages.roleManagement.index': '序号',
  'pages.roleManagement.staffNameEn': '员工姓名(英文)',
  'pages.roleManagement.staffNameCn': '员工姓名(中文)',
  'pages.roleManagement.staffNo': '员工编号',
  'pages.roleManagement.costCenter': '成本中心',
  'pages.roleManagement.creator': '创建人',
  'pages.roleManagement.createdTime': '创建时间',
  'pages.roleManagement.actions': '操作',
  'pages.roleManagement.remove': '移除',
  'pages.roleManagement.addUser': '添加用户',
  'pages.roleManagement.deleteNotification': '删除通知',
  'pages.roleManagement.deleteConfirm': '确定要从{roleName}角色中移除该员工吗？',
  'pages.roleManagement.delete': '删除',
  'pages.roleManagement.deletedSuccess': '删除成功',
  'pages.roleManagement.deletedFailed': '删除失败',
  'pages.roleManagement.addUserTitle': '角色管理',
  'pages.roleManagement.availableUsers': '可用用户',
  'pages.roleManagement.selectedUsers': '已选用户',
  'pages.roleManagement.searchStaff': '搜索员工',
  'pages.roleManagement.add': '添加',
  'pages.roleManagement.removeButton': '移除',
  'pages.roleManagement.noAvailableUsers': '暂无可用用户',
  'pages.roleManagement.selectUsers': '请从左侧选择用户',
  'pages.roleManagement.addSuccess': '用户添加到角色成功',
  'pages.roleManagement.selectRoleFirst': '请先选择角色',
  'pages.roleManagement.selectEmployeesFirst': '请先选择要添加的员工',
  'pages.roleManagement.loading': '加载中...',
  'pages.roleManagement.noRoleData': '暂无角色数据',
  // 参数管理创建页面
  'pages.paramManagement.createParameters': '创建参数',
  'pages.paramManagement.parameterNamePlaceholder': '请输入名称',
  'pages.paramManagement.parameterNameRequired': '参数名称是必填项！',
  'pages.paramManagement.categoryCode': '参数代码',
  'pages.paramManagement.categoryCodePlaceholder': '请输入代码',
  'pages.paramManagement.categoryCodeRequired': '参数代码是必填项！',
  'pages.paramManagement.moduleName': '模块名称',
  'pages.paramManagement.moduleNamePlaceholder': '请输入模块名称',
  'pages.paramManagement.moduleNameRequired': '模块名称是必填项！',
  'pages.paramManagement.remark': '备注',
  'pages.paramManagement.remarkPlaceholder': '请输入备注',
  'pages.paramManagement.remarkRequired': '备注是必填项！',
  'pages.paramManagement.create': '创建',
  'pages.paramManagement.createSuccess': '参数创建成功',
  'pages.paramManagement.createFailed': '参数创建失败',
  // 参数管理配置页面
  'pages.paramManagement.configuration': '参数管理配置',
  'pages.paramManagement.parameterNameLabel': '参数名称',
  'pages.paramManagement.moduleAppliedLabel': '应用模块',
  'pages.paramManagement.name': '名称',
  'pages.paramManagement.id': 'ID',
  'pages.paramManagement.addParameter': '添加参数',
  'pages.paramManagement.removeParameter': '移除参数',
  'pages.paramManagement.noParameters': '未找到参数。点击"+"按钮添加参数。',
  'pages.paramManagement.parameterIdRequired': '参数ID和参数值不能为空',
  'pages.paramManagement.missingCategory': '缺少类别信息',
  'pages.paramManagement.parameterLengthExceeded': '参数ID和参数值不能超过500个字符',
  'pages.paramManagement.saveSuccess': '参数配置保存成功',
  'pages.paramManagement.saveFailed': '参数配置保存失败',
  'pages.paramManagement.loadFailed': '加载参数详情失败',
  'pages.paramManagement.specialCharactersNotAllowed': '不允许特殊字符和表情',
  'pages.paramManagement.maxLength': '最大长度为500个字符',
};
